module.exports = __webpack_public_path__ + "static/jagoda_podrucka-4335b540c68d2662d80b445c7c63fee7.png";